// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"3809156b","376":"b199beac","568":"2f1a4448","584":"2f1a4448","751":"2e30b039","755":"d46476c3","851":"07e6b0d9"}[chunkId] + ".chunk.css";
};